// User CRUD schemas — plan §4.7.1 Kullanıcı Yönetimi + Ek C Users.
import { z } from "zod";

export const UserListItemSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  fullName: z.string(),
  roleId: z.string().uuid(),
  roleName: z.string(),
  isActive: z.boolean(),
  lastLoginAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  // Müşteri Katılımcı Rolü (D14, eng-review) — admin kullanıcı listesinde "Müşteri"
  // rozeti + rol dropdown kilidi için gerekli.
  userKind: z.enum(["internal", "client"]),
});
export type UserListItem = z.infer<typeof UserListItemSchema>;

export const UsersListResponseSchema = z.object({
  users: z.array(UserListItemSchema),
  roles: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      isSystem: z.boolean(),
    }),
  ),
  // M8 — BE pagination
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type UsersListResponse = z.infer<typeof UsersListResponseSchema>;

// M8 — BE query filter + pagination
export const UsersListQuerySchema = z.object({
  search: z.string().max(200).optional(),
  roleId: z.string().uuid().optional(),
  isActive: z
    .union([z.literal("true"), z.literal("false"), z.boolean()])
    .transform((v) => (typeof v === "boolean" ? v : v === "true"))
    .optional(),
  // Finar Ö1/Ö11 — danışman seçicileri yalnız iç kullanıcıları ister (müşteri kullanıcıları hariç).
  userKind: z.enum(["internal", "client"]).optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type UsersListQuery = z.infer<typeof UsersListQuerySchema>;

// M8 — Admin şifre sıfırlama tetikleme response
export const TriggerResetResponseSchema = z.object({
  activationToken: z.string().optional(),
  activationExpiresAt: z.string().datetime().optional(),
  emailSent: z.boolean(),
});
export type TriggerResetResponse = z.infer<typeof TriggerResetResponseSchema>;

// Davet — plan §4.7 invite akışı. Password null; kullanıcı first-login'de belirler.
export const InviteUserRequestSchema = z.object({
  email: z.string().email("Geçerli bir email girin"),
  fullName: z.string().min(2, "Ad soyad en az 2 karakter"),
  roleId: z.string().uuid(),
});
export type InviteUserRequest = z.infer<typeof InviteUserRequestSchema>;

export const InviteUserResponseSchema = z.object({
  user: UserListItemSchema,
  // #011: emailSent flag — UI dinamik mesaj göstermek için.
  // Dev'de + SMTP başarısızsa kullanıcıya activation URL'i manuel iletmek için
  // activationToken da response'a eklenir.
  emailSent: z.boolean(),
  activationToken: z.string().optional(),
  activationExpiresAt: z.string().datetime().optional(),
  activationUrl: z.string().url().optional(),
});
export type InviteUserResponse = z.infer<typeof InviteUserResponseSchema>;

export const UpdateUserRequestSchema = z
  .object({
    fullName: z.string().min(2).optional(),
    roleId: z.string().uuid().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, {
    message: "En az bir alan güncellenmeli",
  });
export type UpdateUserRequest = z.infer<typeof UpdateUserRequestSchema>;
